import { Component, OnInit, Input, Provider, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const SABIS_CHECKBOX_VALUE_PROVIDER: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SabisNgxCheckboxComponent),
  multi: true
};
/**
 * SABIS checkbox control
 * Properties:
 *    scLabel: checkbox label
 *    scTabindex: checkbox tab index
 */
@Component({
  selector: 'sabis-ngx-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [SABIS_CHECKBOX_VALUE_PROVIDER]
})
export class SabisNgxCheckboxComponent implements OnInit, ControlValueAccessor {
  @Input('scLabel') scLabel: string = '';
  @Input('scTabindex') scTabindex: number = 1;
  @Input('required') required: boolean = false;

  isDisabled: boolean = false;
  // isChecked
  get isChecked(): boolean {
    return this._isChecked;
  };
  set isChecked(value: boolean) {
    if (this._isChecked !== value) {
      this._isChecked = value;
      this.onChangeCallback(this._isChecked);
    }
  };

  private _isChecked: boolean = false;
  private onChangeCallback: any = () => { };
  private onTouchedCallback: any = () => { };


  constructor() { }

  ngOnInit() { }

  writeValue(obj: any): void {
    this._isChecked = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  /**
   * internal input model changed
   * @param e
   */
  onCheckboxChange(isChecked: boolean) {
    this.isChecked = isChecked;
  }

  /**
   * Handle checkbox click event
   */
  onClick() {
    this.isChecked = !this.isChecked;
  }

  /**
   * Handle keyboard event
   * @param e Keyboard event
   */
  onKeyPress(e: any) {
    // If 'enter' or 'space' is clicked then change the checked value
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.isChecked = !this.isChecked;
    }
  }
}
